module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/ko/3/4-bccc844769224ab1c301a65a6c7d607a.jpg";